/**
 * The glyphs for the two background-work categories, defined ONCE.
 *
 * They render in two places — the Agentes Lexiun sidebar tabs and the chat
 * infobar's counts segment (operator 2026-07-30: "repeat the same icons") —
 * and the whole point of repeating them is that a lawyer learns one symbol
 * per category. Two files each picking their own `lucide` import is how that
 * quietly stops being true after one refactor, so both import from here.
 *
 * Same one-implementation rule as `isRightSidebarOnScreen` and
 * `resolveGatewayDisplay`: if you change a glyph, you change it for every
 * surface that means the same thing, or you have not changed it at all.
 */
import { Bot, CalendarClock, ListChecks } from "lucide-react";

/** Missions — the "Agentes" category. */
export const AgentsIcon = Bot;

/** Standalone harness + scheduled runs — the "Tarefas" category. */
export const TasksIcon = ListChecks;

/** Agendamentos — scheduled jobs. Same glyph the ActivityBar nav uses. */
export const ScheduleIcon = CalendarClock;
